import React from 'react';
import './Abouteco.css';

const WhatIsAPICProtoHub = () => {
  // Data for the ecosystem cards
  const ecosystemData = [
    {
      number: '01',
      title: 'Innovators',
      description: 'People with ideas and problems that need solutions.',
      icon: '💡'
    },
    {
      number: '02',
      title: 'Experts',
      description: 'Industry professionals, engineers, designers, researchers and domain specialists who guide innovators.',
      icon: '👨‍🔬'
    },
    {
      number: '03',
      title: 'Facility Centres',
      description: 'Advanced facilities with machines, tools and technologies required to develop prototypes.',
      icon: '🏭'
    },
    {
      number: '04',
      title: 'Manufacturing Partners',
      description: 'Manufacturers who take successful prototypes towards production and scale.',
      icon: '⚙️'
    },
    {
      number: '05',
      title: 'Government & Ecosystem',
      description: 'A supportive environment that enables innovation, entrepreneurship, manufacturing and commercialisation.',
      icon: '🏛️'
    }
  ];

  return (
    <div className="about-eco-container">
      <div className="about-eco-wrapper">
        
        {/* Header Section */}
        <div className="about-eco-header">
         
          <p className="about-eco-subtitle">One Platform. One Ecosystem. Infinite Possibilities.</p>
          <p className="about-eco-description">
            A collaborative innovation ecosystem that brings together the people, knowledge, 
            infrastructure and support required to transform ideas into real-world products.
          </p>
        </div>

        {/* Ecosystem Cards - All in One Row */}
        <div className="about-eco-cards-row">
          {ecosystemData.map((item, index) => (
            <div key={index} className="about-eco-card">
              <div className="about-eco-card-icon">{item.icon}</div>
              <div className="about-eco-card-number">{item.number}</div>
              <h3 className="about-eco-card-title">{item.title}</h3>
              <p className="about-eco-card-description">{item.description}</p>
            </div>
          ))}
        </div>


      </div>
    </div>
  );
};

export default WhatIsAPICProtoHub;